export default function block_leaderboard() {
  if ($('.felds-leaderboard-block').length == 0) return;

  resizeLiveTiming();
  $(window).on('load', resizeLiveTiming)
  $(window).on('resize', resizeLiveTiming);

  function resizeLiveTiming() {
    // Create a new timestamp
    var timestamp = new Date().getTime();

    // Append the timestamp as a query parameter to the URL
    var newSrc = 'https://storage.googleapis.com/supercross-live-timing-leaderboard/index.html?_=' + timestamp;

    // Update the iframe's src attribute with the new URL
    $('#live_timing > iframe').attr('src', newSrc);
    // Remove the loading class
    $('#live_timing').removeClass('loading');
  }

  $('#live_timing > iframe').load(function () {
      $('#live_timing').removeClass('loadings');
  });

  // Fetch the visibility status for the live-timing block
  fetch('https://storage.googleapis.com/feld-supercross-automation/automation.json')
      .then(response => response.json())
      .then(data => {
          // Use the 'live-timing' key to decide if the block should be shown
          if (data['live-timing']) {
              $('#live-timing-widget').show();
          } else {
              $('#live-timing-widget').hide();
          }
      })
      .catch(error => console.error('Error fetching block visibility status:', error));
}
